module.exports = __webpack_public_path__ + "static/cep_banner_whoweare-16c8e780b9aca7a66b1c64a668570009.jpg";